import * as React from "react"
import Box from "@mui/material/Box"
import TabsWrappedLabel from "../../../../components/tabs/tabs-component"
import PropTypes from "prop-types"
import { COMPANY_TABS } from "../../tabs/constants"

const CompanyTabsWrappedLabel = ({
    companyTabChildren,
    marketToMarketTabChildren,
    balanceTabChildren,
    emissionTabChildren,
    economicGroupTabChildren,
    otherDocumentsTabChildren,
}) => {
    return (
        <Box
            sx={{
                width: "100%",
            }}
        >
            <TabsWrappedLabel
                tabs={COMPANY_TABS.map((tab) => ({
                    ...tab,
                    content: {
                        company: companyTabChildren,
                        marketToMarket: marketToMarketTabChildren,
                        balance: balanceTabChildren,
                        emission: emissionTabChildren,
                        economicGroup: economicGroupTabChildren,
                        otherDocuments: otherDocumentsTabChildren,
                    }[tab.value],
                }))}
            />
        </Box>
    )
}

CompanyTabsWrappedLabel.propTypes = {
    companyTabChildren: PropTypes.node,
    marketToMarketTabChildren: PropTypes.node,
    balanceTabChildren: PropTypes.node,
    emissionTabChildren: PropTypes.node,
    economicGroupTabChildren: PropTypes.node,
    otherDocumentsTabChildren: PropTypes.node,
}

export default CompanyTabsWrappedLabel
